<template>
    <header class="app-header" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header-left">
            <a href="/" class="brand">
                <div class="brand-logo">
                    <div class="logo-icon">
                        <img src="/images/logo.svg" alt="logo" />
                    </div>
                </div>
                <div class="brand-text">
                    <img src="/images/logo-text.svg" alt="altel" />
                </div>
            </a>
        </div>

        <nav class="header-nav" aria-label="Main">
            <ul class="nav-list">
                <li :class="{ active: href.includes('campaigns') }">
                    <a href="/campaigns">{{ $t("messages.campaigns") }}</a>
                </li>
                <li :class="{ active: href.includes('creative') }">
                    <a href="/creatives">{{ $t("messages.creatives") }}</a>
                </li>

                <template v-if="!isLimitedUser">
                    <div class="separator"></div>
                    <!-- Benchmarks temporarily hidden
                    <li>
                        <a href="#">{{ $t("messages.benchmarks") }}</a>
                    </li>
                    -->
                    <li :class="{ active: href.includes('segments') }">
                        <a href="/segments">{{ $t("messages.segments") }}</a>
                    </li>
                    <!-- <li :class="{ active: href.includes('rich-media') }">
                        <a href="/rich-media">{{ $t("messages.rich_media") }}</a>
                    </li> -->
                    <div class="separator"></div>
                    <li :class="{ active: href.includes('reports') }">
                        <a href="/reports">{{ $t("messages.reports") }}</a>
                    </li>
                </template>
            </ul>
        </nav>

        <div class="header-right">
            <div class="help-icon">
                <img src="/images/circle_help.svg" alt="help" />
            </div>
            <div class="language-switcher">
                <div class="language-select">
                    <div class="language-current" @click="toggleLanguageDropdown">
                        <img :src="getCurrentFlag()" class="flag-icon" alt="lang" />
                    </div>
                    <div class="language-dropdown" :class="{ show: showLanguageDropdown }">
                        <div class="language-option" @click="switchLanguage('ru')">
                            <img src="/images/lang_ru.svg" class="flag-icon" alt="ru" />
                            <span class="language-name">{{
                                $t("messages.russian")
                                }}</span>
                        </div>
                        <div class="language-option" @click="switchLanguage('en')">
                            <img src="/images/lang_us.svg" class="flag-icon" alt="en" />
                            <span class="language-name">{{
                                $t("messages.english")
                                }}</span>
                        </div>
                        <div class="language-option" @click="switchLanguage('kk')">
                            <img src="/images/lang_kz.svg" class="flag-icon" alt="kk" />
                            <span class="language-name">{{
                                $t("messages.kazakh")
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="user-profile">
                <div class="user-profile-container" @click="toggleUserDropdown">
                    <img src="/images/user.svg" alt="profile" />
                </div>
                <div class="user-dropdown" :class="{ show: showUserDropdown }">
                    <div class="user-info">
                        <div class="user-email">
                            {{ $store.getters.user?.email || $t("messages.user") }}
                        </div>
                    </div>
                    <ul class="user-options-list" style="list-style:none;margin:0;padding:0;">
                        <li class="user-option" v-if="isAdmin" @click="update">
                            <span class="users-text">Обновить</span>
                        </li>
                        <li class="user-option" v-if="!isLimitedUser" @click="goToUsers">
                            <span class="users-text">{{ $t("messages.users") }}</span>
                        </li>
                        <li class="dropdown-separator"></li>
                        <li class="user-option" @click="logout">
                            <span class="logout-text">{{ $t("messages.logout") }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="separator"></div>
            <div class="user-organization">
                {{ $store.getters.user?.email || $t("messages.user") }}
            </div>
        </div>
    </header>
</template>

<script>
import axios from "axios";

export default {
    name: "AppHeader",
    data() {
        return {
            href: window.location.href,
            fullscreenLoading: false,
            currentLocale:
                localStorage.getItem("preferred_language") ||
                document.documentElement.lang ||
                "ru",
            showLanguageDropdown: false,
            showUserDropdown: false,
        };
    },
    computed: {
        isLimitedUser() {
            const user = this.$store.getters.user;
            return user && user.roleId === 4;
        },
        // Простая проверка на администратора. При необходимости скорректируй roleId.
        isAdmin() {
            const user = this.$store.getters.user;
            return user && user.roleId === 1;
        },
    },
    mounted() {
        // Синхронизируем язык при загрузке компонента
        this.syncLanguage();

        // Добавляем обработчик клика вне выпадающего меню
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        // Удаляем обработчик при размонтировании компонента
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        syncLanguage() {
            // Синхронизируем язык между localStorage, Vue i18n и HTML
            const savedLanguage = localStorage.getItem("preferred_language");
            const htmlLanguage = document.documentElement.lang;
            const currentLanguage = savedLanguage || htmlLanguage || "ru";

            // Обновляем все источники языка
            this.currentLocale = currentLanguage;
            this.$i18n.locale = currentLanguage;
            document.documentElement.lang = currentLanguage;

            // Сохраняем в localStorage для будущих сессий
            if (!savedLanguage) {
                localStorage.setItem("preferred_language", currentLanguage);
            }
        },
        handleClickOutside(event) {
            // Закрываем выпадающее меню при клике вне его
            const languageSwitcher =
                this.$el.querySelector(".language-switcher");
            const userProfile =
                this.$el.querySelector(".user-profile");

            if (languageSwitcher && !languageSwitcher.contains(event.target)) {
                this.showLanguageDropdown = false;
            }

            if (userProfile && !userProfile.contains(event.target)) {
                this.showUserDropdown = false;
            }
        },
        toggleLanguageDropdown() {
            this.showLanguageDropdown = !this.showLanguageDropdown;
        },
        toggleUserDropdown() {
            this.showUserDropdown = !this.showUserDropdown;
        },
        getCurrentFlag() {
            const flags = {
                ru: "/images/lang_ru.svg",
                en: "/images/lang_us.svg",
                kk: "/images/lang_kz.svg",
            };
            return flags[this.currentLocale] || "/images/lang_ru.svg";
        },
        getCurrentLanguageName() {
            const names = {
                ru: this.$t("messages.russian"),
                en: this.$t("messages.english"),
                kk: this.$t("messages.kazakh"),
            };
            return names[this.currentLocale] || this.$t("messages.russian");
        },
        switchLanguage(lang) {
            this.currentLocale = lang;
            this.showLanguageDropdown = false;

            // Сохраняем выбранный язык в localStorage
            localStorage.setItem("preferred_language", lang);

            // Обновляем атрибут lang в HTML
            document.documentElement.lang = lang;

            // Обновляем язык в Vue i18n (без перезагрузки страницы)
            this.$i18n.locale = lang;

            // Отправляем запрос на сервер для сохранения языка в сессии
            axios
                .post("/change-language", { lang: lang })
                .then(() => { })
                .catch((error) => {
                    // В случае ошибки показываем уведомление, но не перезагружаем
                    this.$notify({
                        title: this.$t("messages.error"),
                        message: this.$t("messages.language_change_error"),
                        type: "error",
                    });
                });
        },
        update() {
            this.fullscreenLoading = true;
            axios
                .post("/update-data")
                .then((response) => {
                    const data = response && response.data ? response.data : {};
                    const message = data.message || this.$t("messages.success");
                    const success = typeof data.success === "boolean" ? data.success : true;

                    this.$notify({
                        title: success ? this.$t("messages.success") : this.$t("messages.error"),
                        message: message,
                        type: success ? "success" : "error",
                    });

                    this.showUserDropdown = false;
                    this.fullscreenLoading = false;
                })
                .catch((error) => {
                    this.$notify({
                        title: this.$t("messages.error"),
                        message: this.$t("messages.error"),
                        type: "error",
                    });
                    this.fullscreenLoading = false;
                });
        },
        logout() {
            this.fullscreenLoading = true;
            axios
                .post("/logout")
                .then((response) => {
                    window.location.href = "/login";
                })
                .catch((error) => {
                    this.$notify({
                        title: this.$t("messages.error"),
                        message: this.$t("messages.error"),
                        type: "error",
                    });
                    this.fullscreenLoading = false;
                });
        },
        goToUsers() {
            this.showUserDropdown = false;
            window.location.href = "/users";
        },
    },
};
</script>
